import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { IconButton, Modal, Portal, Surface, Text, useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { CompleteDriverProfileForm } from './CompleteDriverProfileForm';
import type { DriverProfileBoundaryResponse } from '../api/apiService';

export interface CompleteDriverProfileModalProps {
  visible: boolean;
  onDismiss: () => void;
  onSuccess?: (result?: DriverProfileBoundaryResponse) => void | Promise<void>;
}

export function CompleteDriverProfileModal({
  visible,
  onDismiss,
  onSuccess,
}: CompleteDriverProfileModalProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleSuccess = async (result?: DriverProfileBoundaryResponse) => {
    onDismiss();
    await onSuccess?.(result);
  };

  return (
    <Portal>
      <Modal
        visible={visible}
        onDismiss={onDismiss}
        contentContainerStyle={styles.modalContainer}
        testID="complete-driver-profile-modal"
      >
        <Surface style={[styles.surface, { backgroundColor: theme.colors.surface }]}>
          <View style={styles.header}>
            <Text variant="titleLarge" style={{ color: theme.colors.onSurface }}>
              {t('completeDriverProfile.modalTitle', 'Tornar-me motorista')}
            </Text>
            <IconButton
              icon="close"
              onPress={onDismiss}
              accessibilityLabel={t('common.close', 'Fechar')}
              testID="complete-driver-profile-close"
            />
          </View>
          <Text
            variant="bodyMedium"
            style={[styles.notice, { color: theme.colors.onSurfaceVariant }]}
          >
            {t(
              'completeDriverProfile.boundaryNotice',
              'Vai usar uma das licenças livres da empresa.',
            )}
          </Text>
          <CompleteDriverProfileForm
            onSuccess={handleSuccess}
            submitLabel={t('completeDriverProfile.becomeDriverSubmit', 'Tornar-me motorista')}
          />
        </Surface>
      </Modal>
    </Portal>
  );
}

const styles = StyleSheet.create({
  modalContainer: {
    alignSelf: 'center',
    width: '94%',
    maxWidth: Platform.OS === 'web' ? 560 : undefined,
    maxHeight: '94%',
  },
  surface: {
    borderRadius: 16,
    overflow: 'hidden',
    maxHeight: '100%',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 20,
    paddingRight: 8,
    paddingTop: 8,
  },
  notice: {
    paddingHorizontal: 20,
    paddingBottom: 8,
  },
});
